import { ContentSidePadding } from "components/ContentSidePadding";
import { ItemsDirectoryContainer } from "@ugg/shared/components/Items/ItemsDirectoryContainer";
import { FreestarLeftRail, FreestarRightRail } from "components/Ads/FreestarRails";
import { MediaQuery } from "@outplayed/responsive";

export function ItemsDirectory() {
  return (
    <div className="flex justify-center mx-auto w-full max-md:w-full">
      <MediaQuery min="DESKTOP_SMALL" max="DESKTOP_LARGE" renderNullOnFail isClient>
        <div className="flex-1 min-w-0 mr-[-12px]">
          <FreestarLeftRail className="sticky top-[calc(var(--masthead-height)+100px)] transition-[top]" />
        </div>
      </MediaQuery>
      <ContentSidePadding className="mx-auto w-[1014px] max-md:w-full box-content">
        <ItemsDirectoryContainer />
      </ContentSidePadding>
      <MediaQuery min="DESKTOP_SMALL" max="DESKTOP_LARGE" renderNullOnFail isClient>
        <div className="flex-1 min-w-0 ml-[-12px]">
          <FreestarRightRail className="sticky top-[calc(var(--masthead-height)+100px)] transition-[top]" />
        </div>
      </MediaQuery>
    </div>
  );
}
